import React from 'react';

import { Container } from './styles';

const Footer = ({ marginBottom }) => (
  <Container marginBottom={marginBottom}>
    <p>
      <span>&reg; Reforma Fácil Serviços de Internet</span>
      {' - CNPJ: 33.797.610/0001-17 - Av. Eugênia 630 - Centro - Carapicuíba - SP - CEP: 06322-010.'}
    </p>
  </Container>
);

export default Footer;
